import {useCallback} from 'react'
import {usePrefersReducedMotion} from '@github-ui/use-prefers-reduced-motion'
import {OVERVIEW_MERGE_BOX_ANCHOR_ID} from '../../../helpers/constants'

export function useScrollToMergeBox() {
  const prefersReducedMotion = usePrefersReducedMotion()

  return useCallback(() => {
    const mergeBox = document.getElementById(OVERVIEW_MERGE_BOX_ANCHOR_ID)
    if (!mergeBox) return

    mergeBox.scrollIntoView({behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start'})
    mergeBox.focus({preventScroll: true})
  }, [prefersReducedMotion])
}
